import _Object$assign from "babel-runtime/core-js/object/assign";
import _extends from "babel-runtime/helpers/extends";
import _typeof from "babel-runtime/helpers/typeof";


import stringConfig from "../../tools/stringConfig.js";

export default {
  getModuleObjctFoyKey: function getModuleObjctFoyKey(_this, moduleKey, paths, saveHideField) {
    var that = this;
    var emptyObject = {};

    var _loop = function _loop(gk) {
      var _loop2 = function _loop2(md) {
        if (md == moduleKey) {
          if (_this.groupDatas[gk][md].length == 1) {
            that.moduleFieldsToObj(_this, gk, emptyObject, md, 0);
            for (var fk in _this.groupDatas[gk][md][0]["FIELDS"]) {
              if (!saveHideField && _this.groupDatas[gk][md][0]["FIELDS"][fk].FIELD_CONTROL == "1") {
                continue;
              }
              var tmpVal = _this.groupDatas[gk][md][0]["FIELDS"][fk].DEFAULT_VALUE;
              if (typeof tmpVal == "string") {
                emptyObject[fk] = tmpVal.trim();
              } else {
                emptyObject[fk] = tmpVal;
              }
              if ("DATA_SOURCE" in _this.groupDatas[gk][md][0]["FIELDS"][fk]) {
                emptyObject[fk + "_DATA_SOURCE"] = _this.groupDatas[gk][md][0]["FIELDS"][fk].DATA_SOURCE;
              }
            }
            return {
              v: {
                v: emptyObject
              }
            };
          } else {
            var emptyArr = [];
            _.each(_this.groupDatas[gk][md], function (obj, index) {
              that.moduleFieldsToObj(_this, gk, emptyObject, md, index);
              for (var _fk in obj["FIELDS"]) {
                if (!saveHideField && obj["FIELDS"][_fk].FIELD_CONTROL == "1") {
                  continue;
                }
                var _tmpVal = obj["FIELDS"][_fk].DEFAULT_VALUE;
                if (typeof _tmpVal == "string") {
                  emptyObject[_fk] = _tmpVal.trim();
                } else {
                  emptyObject[_fk] = _tmpVal;
                }
                if ("DATA_SOURCE" in obj["FIELDS"][_fk]) {
                  emptyObject[_fk + "_DATA_SOURCE"] = obj["FIELDS"][_fk].DATA_SOURCE;
                }
              }
              emptyArr.push(emptyObject);
              emptyObject = {};
            });
            return {
              v: {
                v: emptyArr
              }
            };
          }
        }
      };

      for (var md in _this.groupDatas[gk]) {
        var _ret2 = _loop2(md);

        if ((typeof _ret2 === "undefined" ? "undefined" : _typeof(_ret2)) === "object") return _ret2.v;
      }
    };

    for (var gk in _this.groupDatas) {
      var _ret = _loop(gk);

      if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
    }
  },

  moduleFieldsToObj: function moduleFieldsToObj(_this, gk, emptyObject, md, index) {
    var moduleObj = _this.groupDatas[gk][md][index];
    moduleObj.MODULE_WITHOUT && (emptyObject.MODULE_WITHOUT = moduleObj.MODULE_WITHOUT);
    moduleObj.withoutChecked && (emptyObject.withoutChecked = moduleObj.withoutChecked);
    moduleObj.MODULE_SAME && (emptyObject.MODULE_SAME = moduleObj.MODULE_SAME);
    moduleObj.sameChecked && (emptyObject.sameChecked = moduleObj.sameChecked);
    moduleObj.MODULE_NUMBER && (emptyObject.MODULE_NUMBER = moduleObj.MODULE_NUMBER || index);
  },

  getModuleObjctFoyPrefixKey: function getModuleObjctFoyPrefixKey(_this, moduleKey, paths, saveHideField, preFixkeys) {
    var emptyObject = {},
        replaceObj = null,
        replaceKeys = "";
    if (_.isObject(preFixkeys)) {
      replaceObj = preFixkeys;
    } else {
      replaceKeys = preFixkeys;
    }
    for (var gk in _this.groupDatas) {
      for (var md in _this.groupDatas[gk]) {
        if (md == moduleKey) {
          if (_this.groupDatas[gk][md].length == 1) {
            for (var fk in _this.groupDatas[gk][md][0]["FIELDS"]) {
              if (!saveHideField && _this.groupDatas[gk][md][0]["FIELDS"][fk].FIELD_CONTROL == "1") {
                continue;
              }
              var tmpVal = _this.groupDatas[gk][md][0]["FIELDS"][fk].DEFAULT_VALUE;
              if (typeof tmpVal == "string") {
                emptyObject[fk] = tmpVal.trim();
              } else {
                emptyObject[fk] = tmpVal;
              }
              if ("DATA_SOURCE" in _this.groupDatas[gk][md][0]["FIELDS"][fk]) {
                emptyObject[fk + "_DATA_SOURCE"] = _this.groupDatas[gk][md][0]["FIELDS"][fk].DATA_SOURCE;
              }
            }
            return emptyObject;
          } else {
            var _ret3 = function () {
              var emptyArr = [];
              _.each(_this.groupDatas[gk][md], function (obj, index) {
                for (var _fk2 in obj["FIELDS"]) {
                  if (!saveHideField && obj["FIELDS"][_fk2].FIELD_CONTROL == "1") {
                    continue;
                  }
                  var _tmpVal2 = obj["FIELDS"][_fk2].DEFAULT_VALUE;
                  if (typeof _tmpVal2 == "string") {
                    emptyObject[_fk2] = _tmpVal2.trim();
                  } else {
                    emptyObject[_fk2] = _tmpVal2;
                  }
                  if ("DATA_SOURCE" in obj["FIELDS"][_fk2]) {
                    emptyObject[_fk2 + "_DATA_SOURCE"] = obj["FIELDS"][_fk2].DATA_SOURCE;
                  }
                }
                emptyArr.push(emptyObject);
                emptyObject = {};
              });
              return {
                v: emptyArr
              };
            }();

            if ((typeof _ret3 === "undefined" ? "undefined" : _typeof(_ret3)) === "object") return _ret3.v;
          }
        }
      }
    }
  },

  getModuleUpdateFlagByPaths: function getModuleUpdateFlagByPaths(_this, paths, newMd) {
    if (_this.apptStatus >= 4) {
      var _ret4 = function () {
        var oldAllData = {};
        if (!_.isArray(newMd)) {
          paths.forEach(function (path) {
            if (path) {
              var oldModule = _.get(_this.historyData, path);
              if (_.isArray(oldModule) && oldModule.length) {
                oldModule = oldModule[0];
              }
              oldAllData = _extends({}, oldAllData, oldModule);
            }
          });
          for (var fk in newMd) {
            if (fk.indexOf("DATA_SOURCE") != -1) {
              continue;
            }

            var oldUpdateFlag = _.get(oldAllData, "" + (fk + "_UPDATE_FLAG"));
            if (oldUpdateFlag !== undefined) {
              newMd[fk + "_UPDATE_FLAG"] = oldUpdateFlag;
            }

            if (_.get(oldAllData, "" + fk) != _.get(newMd, "" + fk)) {
              newMd[fk + "_UPDATE_FLAG"] = "1";
            }
          }
        } else {
          var _loop3 = function _loop3(i) {
            var newMdObj = newMd[i];
            paths.forEach(function (path) {
              if (path) {
                var oldModule = _.get(_this.historyData, path);
                if (_.isArray(oldModule) && oldModule.length) {
                  oldModule = oldModule[i];
                }
                oldAllData = _extends({}, oldAllData, oldModule);
              }
            });
            for (var _fk3 in newMdObj) {
              if (_fk3.indexOf("DATA_SOURCE") != -1) {
                continue;
              }

              var _oldUpdateFlag = _.get(oldAllData, "" + (_fk3 + "_UPDATE_FLAG"));
              if (_oldUpdateFlag !== undefined) {
                newMdObj[_fk3 + "_UPDATE_FLAG"] = _oldUpdateFlag;
              }

              if (_.get(oldAllData, "" + _fk3) != _.get(newMdObj, "" + _fk3)) {
                newMdObj[_fk3 + "_UPDATE_FLAG"] = "1";
              }
            }
          };

          for (var i = 0; i < newMd.length; i++) {
            _loop3(i);
          }
        }
        return {
          v: newMd
        };
      }();

      if ((typeof _ret4 === "undefined" ? "undefined" : _typeof(_ret4)) === "object") return _ret4.v;
    }
  },

  getEmptySaveObject: function getEmptySaveObject(keyFieldMapData) {
    var saveObject = {};
    _.forEach(keyFieldMapData, function (jsonValue, jsonKey) {
      saveObject[jsonKey] = "";
    });
    return saveObject;
  },

  setDataWithNewObject: function setDataWithNewObject(_this, saveData, mouduleArr, oldObject) {
    _.forEach(saveData, function (jsonValue, jsonKey) {
      for (var gk in _this.groupDatas) {
        var gkBreakBool = false;
        for (var md in _this.groupDatas[gk]) {
          var mdBreakBool = false;
          if (_.indexOf(mouduleArr, md) != -1) {
            for (var fk in _this.groupDatas[gk][md][0]["FIELDS"]) {
              ;
              if (fk == jsonKey) {
                saveData[fk] = _this.groupDatas[gk][md][0]["FIELDS"][fk].DEFAULT_VALUE;
                mdBreakBool = true;
                break;
              }
            }
          }
          if (mdBreakBool) {
            mdBreakBool = false;
            gkBreakBool = true;
            break;
          }
        }
        if (gkBreakBool) {
          gkBreakBool = false;
          break;
        }
      }
    });

    _.forEach(saveData, function (jsonValue, jsonKey) {
      if (stringConfig.isEmptyStr(jsonValue)) {
        if (jsonKey in oldObject) {
          saveData[jsonKey] = oldObject[jsonKey] || "";
        }
      }
    });
    return saveData;
  },

  getSaveCustTaxData: function getSaveCustTaxData(_this, saveTaxInfo, modulesData, oldObject) {
    _.forEach(modulesData, function (item, index) {
      for (var fk in item.FIELDS) {
        var saveKey = fk;
        if (index != 0) {
          saveKey = saveKey + (index + 1);
        }
        saveTaxInfo[saveKey] = item.FIELDS[fk].DEFAULT_VALUE;
        if (!_.isEmpty(oldObject)) {
          if (saveTaxInfo[saveKey] != oldObject[saveKey] && (stringConfig.isNotEmptyStr(saveTaxInfo[saveKey]) || stringConfig.isNotEmptyStr(oldObject[saveKey]))) {
            saveTaxInfo.DIFF_INFO.push({ FIELD: saveKey, OLD: oldObject[saveKey] || "", NEW: saveTaxInfo[saveKey] });
          }
        }
      }
    });
    return saveTaxInfo;
  },

  getSaveCustPayMentTaxData: function getSaveCustPayMentTaxData(_this, saveTaxInfo, modulesData, oldObject) {
    _.forEach(modulesData, function (item, index) {
      consoleLog("item===", item);
      consoleLog("index===", index);

      var _loop4 = function _loop4(fk) {
        ;
        var saveKey = item.FIELDS[fk].FIELD_ID;
        var paymentAmntKey = "PAYMENT_AMNT" + (index + 1);
        saveKey = saveKey + (index + 1);
        saveTaxInfo[saveKey] = item.FIELDS[fk].DEFAULT_VALUE;
        saveTaxInfo[paymentAmntKey] = saveTaxInfo["PAYMENT_ASSET" + (index + 1)] + "&&" + saveTaxInfo["PAYMENT_CURR" + (index + 1)];
        if (saveTaxInfo[saveKey] != oldObject[saveKey] && (stringConfig.isNotEmptyStr(saveTaxInfo[saveKey]) || stringConfig.isNotEmptyStr(oldObject[saveKey]))) {
          saveTaxInfo.DIFF_INFO.push({ FIELD: saveKey, OLD: oldObject[saveKey] || "", NEW: saveTaxInfo[saveKey] });
          if (saveKey.indexOf("PAYMENT_ASSET") != -1 || saveKey.indexOf("PAYMENT_CURR") != -1 && _.findIndex(saveTaxInfo.DIFF_INFO, function (o) {
            return o.FIELD == paymentAmntKey;
          }) == -1) {
            saveTaxInfo.DIFF_INFO.push({ FIELD: paymentAmntKey, OLD: "", NEW: saveTaxInfo[paymentAmntKey] });
          }
        }
      };

      for (var fk in item.FIELDS) {
        _loop4(fk);
      }
    });
    return saveTaxInfo;
  },
  getSavePaymentAssetData: function getSavePaymentAssetData(_this, saveTaxInfo, modulesData, oldObject) {
    _.forEach(modulesData, function (item, index) {
      for (var fk in item.FIELDS) {
        var paymentAmnt = "PAYMENT_AMNT";
        var _saveKey = item.FIELDS[fk].FIELD_ID;
        paymentAmnt = paymentAmnt + (index + 1);
        _saveKey = _saveKey + (index + 1);
        saveTaxInfo[_saveKey] = item.FIELDS[fk].DEFAULT_VALUE;

        if (_saveKey.indexOf("PAYMENT_ASSET") != -1) {
          saveTaxInfo[paymentAmnt] = saveTaxInfo[_saveKey] + "&&";
        }
        if (_saveKey.indexOf("PAYMENT_CURR") != -1) {
          saveTaxInfo[paymentAmnt] = saveTaxInfo[paymentAmnt] + saveTaxInfo[_saveKey];
        }
        if (saveTaxInfo[_saveKey] != oldObject[_saveKey] && (stringConfig.isNotEmptyStr(saveTaxInfo[_saveKey]) || stringConfig.isNotEmptyStr(oldObject[_saveKey]))) {
          saveTaxInfo.DIFF_INFO.push({ FIELD: _saveKey, OLD: oldObject[_saveKey] || "", NEW: saveTaxInfo[_saveKey] });
          if (_saveKey.indexOf("PAYMENT_ASSET") != -1 || _saveKey.indexOf("PAYMENT_CURR") != -1) {
            saveTaxInfo.DIFF_INFO.push({ FIELD: paymentAmnt, OLD: "", NEW: saveTaxInfo[paymentAmnt] });
          }
        }
      }
    });
    return saveTaxInfo;
  },

  getSaveMonamntData: function getSaveMonamntData(_this, saveTaxInfo, modulesData, oldObject) {
    _.forEach(modulesData, function (item) {
      for (var fk in item.FIELDS) {
        var _saveKey2 = item.FIELDS[fk].FIELD_ID;
        saveTaxInfo[_saveKey2] = item.FIELDS[fk].DEFAULT_VALUE;
        if (saveTaxInfo[_saveKey2] != oldObject[_saveKey2] && (stringConfig.isNotEmptyStr(saveTaxInfo[_saveKey2]) || stringConfig.isNotEmptyStr(oldObject[_saveKey2]))) {
          saveTaxInfo.DIFF_INFO.push({ FIELD: _saveKey2, OLD: oldObject[_saveKey2] || "", NEW: saveTaxInfo[_saveKey2] });
        }
      }
    });
    return saveTaxInfo;
  },

  getNewBaseForm: function getNewBaseForm(_this, newBaseForm) {
    var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);
    var newForm = {
      "USER_FNAME": stringConfig.isNotEmptyStr(newBaseForm.USER_FNAME.DEFAULT_VALUE) && newBaseForm.USER_FNAME.DEFAULT_VALUE || "",
      "USER_NAME": stringConfig.isNotEmptyStr(newBaseForm.USER_NAME.DEFAULT_VALUE) && newBaseForm.USER_NAME.DEFAULT_VALUE || "",
      "ID_TYPE": stringConfig.isNotEmptyStr(newBaseForm.ID_TYPE.DEFAULT_VALUE) && newBaseForm.ID_TYPE.DEFAULT_VALUE || "",
      "ID_CODE": stringConfig.isNotEmptyStr(newBaseForm.ID_CODE.DEFAULT_VALUE) && newBaseForm.ID_CODE.DEFAULT_VALUE || "",
      "ID_BEG_DATE": stringConfig.isNotEmptyStr(newBaseForm.ID_BEG_DATE.DEFAULT_VALUE) && newBaseForm.ID_BEG_DATE.DEFAULT_VALUE || "",
      "ID_EXP_DATE": stringConfig.isNotEmptyStr(newBaseForm.ID_EXP_DATE.DEFAULT_VALUE) && newBaseForm.ID_EXP_DATE.DEFAULT_VALUE || "",
      "ID_ISS_AGCY": stringConfig.isNotEmptyStr(newBaseForm.ID_ISS_AGCY.DEFAULT_VALUE) && newBaseForm.ID_ISS_AGCY.DEFAULT_VALUE || "",
      "ID_ADDR": stringConfig.isNotEmptyStr(newBaseForm.ID_ADDR.DEFAULT_VALUE) && newBaseForm.ID_ADDR.DEFAULT_VALUE || "",
      "IDCARD_TYPE": _this.$storage.getSession(_this.$definecfg.READ_CARD) == 1 ? "2" : customerInfo.IDCARD_TYPE,
      "FULLNAME": newBaseForm.FULLNAME && stringConfig.isNotEmptyStr(newBaseForm.FULLNAME.DEFAULT_VALUE) && newBaseForm.FULLNAME.DEFAULT_VALUE || "",
      "IDTYPE": newBaseForm.IDTYPE && stringConfig.isNotEmptyStr(newBaseForm.IDTYPE.DEFAULT_VALUE) && newBaseForm.IDTYPE.DEFAULT_VALUE || ""
    };
    if (_.indexOf(["0b", "0c", "0d", "0e", "0i", "0j", "0s"], customerInfo.ID_TYPE) != -1) {
      _Object$assign(newForm, {
        "OTHER_CUST_NAME": stringConfig.isNotEmptyStr(newBaseForm.OTHER_CUST_NAME.DEFAULT_VALUE) && newBaseForm.OTHER_CUST_NAME.DEFAULT_VALUE || "",
        "OTHER_ID_CODE": stringConfig.isNotEmptyStr(newBaseForm.OTHER_ID_CODE.DEFAULT_VALUE) && newBaseForm.OTHER_ID_CODE.DEFAULT_VALUE || "",
        "OTHER_ID_EXP_DATE": stringConfig.isNotEmptyStr(newBaseForm.OTHER_ID_EXP_DATE.DEFAULT_VALUE) && newBaseForm.OTHER_ID_EXP_DATE.DEFAULT_VALUE || "",
        "OTHER_ID_TYPE": stringConfig.isNotEmptyStr(newBaseForm.OTHER_ID_TYPE.DEFAULT_VALUE) && newBaseForm.OTHER_ID_TYPE.DEFAULT_VALUE || "",

        "FZ_ID_ADDR": stringConfig.isNotEmptyStr(newBaseForm.OTHER_ID_ADDR.DEFAULT_VALUE) && newBaseForm.OTHER_ID_ADDR.DEFAULT_VALUE || "",
        "FZ_ID_CODE": stringConfig.isNotEmptyStr(newBaseForm.OTHER_ID_CODE.DEFAULT_VALUE) && newBaseForm.OTHER_ID_CODE.DEFAULT_VALUE || "",
        "FZ_ID_EXP_DATE": stringConfig.isNotEmptyStr(newBaseForm.OTHER_ID_EXP_DATE.DEFAULT_VALUE) && newBaseForm.OTHER_ID_EXP_DATE.DEFAULT_VALUE || "",
        "FZ_ID_TYPE": stringConfig.isNotEmptyStr(newBaseForm.OTHER_ID_TYPE.DEFAULT_VALUE) && newBaseForm.OTHER_ID_TYPE.DEFAULT_VALUE || ""
      });
    }
    if (newForm.EDUCATION != undefined) {
      newBaseForm.EDUCATION = stringConfig.isNotEmptyStr(newBaseForm.EDUCATION.DEFAULT_VALUE) && newBaseForm.EDUCATION.DEFAULT_VALUE || "";
    }
    if (newForm.MAIL_ADDR != undefined) {
      newBaseForm.MAIL_ADDR = stringConfig.isNotEmptyStr(newBaseForm.MAIL_ADDR.DEFAULT_VALUE) && newBaseForm.MAIL_ADDR.DEFAULT_VALUE || "";
    }
    if (newForm.MAIL_ZIP_CODE != undefined) {
      newBaseForm.MAIL_ZIP_CODE = stringConfig.isNotEmptyStr(newBaseForm.MAIL_ZIP_CODE.DEFAULT_VALUE) && newBaseForm.MAIL_ZIP_CODE.DEFAULT_VALUE || "";
    }
    if (newForm.EMAIL != undefined) {
      newBaseForm.EMAIL = stringConfig.isNotEmptyStr(newBaseForm.EMAIL.DEFAULT_VALUE) && newBaseForm.EMAIL.DEFAULT_VALUE || "";
    }
    if (newForm.BIRTHDAY != undefined) {
      newBaseForm.BIRTHDAY = stringConfig.isNotEmptyStr(newBaseForm.BIRTHDAY.DEFAULT_VALUE) && newBaseForm.BIRTHDAY.DEFAULT_VALUE || "";
    }
    if (newForm.OCCU_TYPE != undefined) {
      newForm.OCCU_TYPE = stringConfig.isNotEmptyStr(newBaseForm.OCCU_TYPE.DEFAULT_VALUE) && newBaseForm.OCCU_TYPE.DEFAULT_VALUE || "";
    }
    if (newForm.OCCU_STATUS != undefined) {
      newForm.OCCU_STATUS = stringConfig.isNotEmptyStr(newBaseForm.OCCU_STATUS.DEFAULT_VALUE) && newBaseForm.OCCU_STATUS.DEFAULT_VALUE || "";
    }
    if (newForm.INDUS_GB != undefined) {
      newForm.INDUS_GB = stringConfig.isNotEmptyStr(newBaseForm.INDUS_GB.DEFAULT_VALUE) && newBaseForm.INDUS_GB.DEFAULT_VALUE || "";
    }
    if (newForm.INDUS_GB_SUB != undefined) {
      newForm.INDUS_GB_SUB = stringConfig.isNotEmptyStr(newBaseForm.INDUS_GB_SUB.DEFAULT_VALUE) && newBaseForm.INDUS_GB_SUB.DEFAULT_VALUE || "";
    }
    if (newForm.OCCU_GB != undefined) {
      newForm.OCCU_GB = stringConfig.isNotEmptyStr(newBaseForm.OCCU_GB.DEFAULT_VALUE) && newBaseForm.OCCU_GB.DEFAULT_VALUE || "";
    }
    if (newForm.OCCU_GB_SUB != undefined) {
      newForm.OCCU_GB_SUB = stringConfig.isNotEmptyStr(newBaseForm.OCCU_GB_SUB.DEFAULT_VALUE) && newBaseForm.OCCU_GB_SUB.DEFAULT_VALUE || "";
    }
    _this.oppBusiData.IDCARD_TYPE = newForm.IDCARD_TYPE;
    return newForm;
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/business/businessTools/bizPublicSaveMethod.js
// module id = 19
// module chunks = 2